// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeDeviceRegisterBody = {
  expoPushToken: string;
  platform: "ios" | "android";
  deviceId: string;
  appVersion: string;
};

export type typeDeviceRegisterOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { isRegistered: boolean };
};

export type typeDeviceRegisterOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeDeviceRegisterOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeDeviceRegisterOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaDeviceRegisterBody = {
  type: "object",
  properties: {
    expoPushToken: { type: "string", maxLength: 3000, minLength: 1 },
    platform: { type: "string", enum: ["ios", "android"] },
    deviceId: { type: "string", maxLength: 3000, minLength: 1 },
    appVersion: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["expoPushToken", "platform", "deviceId", "appVersion"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createDeviceRegister(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaDeviceRegisterBody);
  }

  return async function postDeviceRegister(
    payload: typeDeviceRegisterBody,
  ): Promise<typeDeviceRegisterOutput200 | typeDeviceRegisterOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postDeviceRegister" failed before calling the network. #b0a8fb4ac582`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#b0a8fb4ac582" },
        },
        data: null,
      } as typeDeviceRegisterOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/device/register`,
      httpMethod: "POST",
      options,
    })) as typeDeviceRegisterOutput200 | typeDeviceRegisterOutput400;
  };
}
